import {ExFormDto, ScheduleDto, ScheduleTypeDto} from "../../core/interfaces/core.types";

export enum CustomerInteractionTypeInternalEnum {
  none,
  request_offer,
  activate_autopilot,
  contact_us
}
export interface UserInteractionTypeInfoStepDto {
  uiPriority: number;
  uiHeader: string;
  uiDescription: string;
  uiImageUrl: string;
}

export interface InteractionDocumentDto {

  id?: number;
  interactionId: number;
  name: string;
  fileBase64: string;
  fileBase64MimeType: string;

}

export enum CustomerInteractionStatusInternal {
  created,
  form_updated,
  completed
}

export interface UserInteractionDto {

  id: number;

  typeId: number;

  appointment?: ScheduleDto;

  form?: ExFormDto;

  status: CustomerInteractionStatusInternal;

  documents?: InteractionDocumentDto[];

  ticketId?: string;

  typeDto: UserInteractionTypeDto;

}

export interface UserInteractionTypeOverviewDto {
  interactionTypes: UserInteractionTypeDto[];
}

export interface UserInteractionTypeDto {

  id: number;
  internalType: CustomerInteractionTypeInternalEnum;
  hasForm: boolean;
  form: ExFormDto;

  hasAppointmentSchedule: boolean;
  appointmentMandatory: boolean;
  scheduleTypes:ScheduleTypeDto[];

  allowDocumentUpload: boolean;
  name: string;
  alias: string;

  euHideInOverview: boolean;
  createTicket: boolean;

  euPriority: number;
  appointmentTypeId: number;

  euName: string;
  euDescription: string;
  euOverviewImageUrl: string;
  euImageUrl: string;
  euUrl: string;

  euSuccessMessage: string;
  euSuccessImageUrl: string;
  messageOnUpdate: string;

  hasInfoSteps: boolean;
  infoSteps: UserInteractionTypeInfoStepDto[];


}
